// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"9ad5a83c","784":"d3c6b6f9","808":"26a0cc3d","863":"d8309446"}[chunkId] + ".chunk.css";
};